import * as Auth from '../constants/auth.constant'
import * as App from '../constants/app.constant'
import * as authService from '../services/auth.service'
import { fromPromise } from 'rxjs/observable/fromPromise'
import { from } from 'rxjs/observable/from'
import { switchMap, map, catchError, finalize, tap } from 'rxjs/operators'
import { loading } from './app.epic'
import history from '../components/utils/history'
import { ofType } from 'redux-observable'
import { User } from '../interfaces/user'
const signin = action$ => {
  return action$.pipe(
    ofType(Auth.PROCESS_SIGN_IN),
    tap(() => loading.show()),
    map((action: any) => action.payload),
    switchMap((payload: any) =>
      fromPromise(authService.signin(payload)).pipe(
        map(result => ({
          type: Auth.DONE_SIGN_IN,
          payload: result,
        })),
        catchError(error =>
          from([
            { type: Auth.FAILURE_SIGN_IN, payload },
            { type: App.SHOW_ERROR, payload: error.message },
          ])
        ),
        finalize(() => loading.hide())
      )
    )
  )
}

const successSignin = action$ => {
  return action$.pipe(
    ofType(Auth.DONE_SIGN_IN),
    map((action: any) => action.payload),
    switchMap(() =>
      fromPromise(Promise.resolve()).pipe(
        map(() => ({
          type: App.SHOW_SUCCESS,
          payload: 'ログインに成功しました',
        })),
        finalize(() => history.push('/report'))
      )
    )
  )
}

const signout = action$ => {
  return action$.pipe(
    ofType(Auth.PROCESS_SIGN_OUT),
    tap(() => loading.show()),
    map((action: any) => action.payload),
    switchMap((payload: any) =>
      fromPromise(authService.signOut()).pipe(
        map(() => ({
          type: Auth.DONE_SIGN_OUT,
          payload: {},
        })),
        catchError(error =>
          from([
            { type: Auth.FAILURE_SIGN_OUT, payload },
            { type: App.SHOW_ERROR, payload: error.message },
          ])
        ),
        finalize(() => loading.hide())
      )
    )
  )
}

const successSignout = action$ => {
  return action$.pipe(
    ofType(Auth.DONE_SIGN_OUT),
    map((action: any) => action.payload),
    switchMap(() =>
      fromPromise(Promise.resolve()).pipe(
        map(() => ({
          type: App.SHOW_SUCCESS,
          payload: 'ログアウトしました',
        })),
        finalize(() => history.push('/'))
      )
    )
  )
}

const getSession = action$ => {
  return action$.pipe(
    ofType(Auth.PROCESS_GET_SESSION),
    map((action: any) => action.payload),
    switchMap(() =>
      fromPromise(authService.getSession()).pipe(
        map((payload: User) => ({
          type: Auth.DONE_GET_SESSION,
          payload,
        })),
        catchError(error =>
          from([
            { type: Auth.FAILURE_GET_SESSION },
            { type: App.SHOW_ERROR, payload: error },
          ])
        ),
        finalize(() => loading.hide())
      )
    )
  )
}

const successGetSession = action$ => {
  return action$.pipe(
    ofType(Auth.DONE_GET_SESSION),
    map((action: any) => action.payload),
    switchMap(() =>
      fromPromise(Promise.resolve()).pipe(
        map(() => ({
          type: Auth.SUCCESS_GET_SESSION,
        })),
        finalize(() => history.push('/report'))
      )
    )
  )
}

export default [
  signin,
  successSignin,
  signout,
  successSignout,
  getSession,
  successGetSession,
]



// WEBPACK FOOTER //
// ./src/epics/auth.epic.ts